import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card dashboard-widget h-100" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title fw-bolder mb-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" всё в порядке ")
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted me-3"
}
const _hoisted_7 = { class: "card-body pt-2" }
const _hoisted_8 = {
  key: 0,
  class: "dashboard-widget__error"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Повторить ")
const _hoisted_10 = {
  key: 2,
  class: "dashboard-widget__placeholder"
}
const _hoisted_11 = {
  key: 0,
  class: "card-footer border-0 pt-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        (_ctx.attention > 0)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "ms-3",
              size: "small",
              type: "danger"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" требует внимания: " + _toDisplayString(_ctx.attention), 1)
              ]),
              _: 1
            }))
          : (_ctx.loaded)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                class: "ms-3",
                size: "small",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.updatedAt)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.time), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          size: "mini",
          icon: "el-icon-refresh",
          circle: "",
          loading: _ctx.loading,
          title: "Обновить",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
        }, null, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.error), 1),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh')))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({ 'dashboard-widget__stale': _ctx.error })
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : (!_ctx.error)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, null, 512)), [
              [_directive_loading, true]
            ])
          : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.actions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "actions")
        ]))
      : _createCommentVNode("", true)
  ]))
}